import React from 'react';
import { Variables } from '../index';
export interface LogoProps extends React.SVGAttributes<SVGElement> {
    /**
     *  Color for the logo.
     *  @default Text body color
     */
    color?: string | 'inherit';
    /**
     *  Width of the logo
     *  @default 53
     */
    width?: number;
    /**
     *  Height of the logo
     *  @default 111
     */
    height?: number;
    /**
     *  Test id for unit and e2e
     */
    testId?: string;
}

export const Logo = React.forwardRef<SVGSVGElement, LogoProps>((props, ref) => {
    const { width = 53, height = 111, color = Variables.css.textBody, testId, ...passThroughProps } = props;

    return (
        <svg
            ref={ref}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 53 111"
            color={color}
            data-testid={testId}
            {...passThroughProps}
        >
            <title>Catapult Sports</title>
            <path
                fill="currentColor"
                d="M7.234 33.799l39.093-24.64 5.752-3.631V0L32.485 12.454l-21.43 13.557C3.848 30.544.897 35.87 0 40.187A31.03 31.03 0 017.234 33.8zm44.845-6.308v-5.474L9.382 49.467C3.767 53.502.054 59.084.054 66.118c-.002 3.027.701 6.014 2.055 8.73a19.75 19.75 0 005.75 6.925l44.234 28.446V86.333l-35.11-21.775a8.236 8.236 0 01-2.697-2.956 8.133 8.133 0 01-.974-3.863 7.92 7.92 0 01.964-3.823 8.022 8.022 0 012.694-2.902l35.11-23.523zM9.627 37.834C3.005 41.989.49 46.508.11 51.767a39.737 39.737 0 018.825-7.666l43.145-27.585v-5.541L9.627 37.834z"
            ></path>
        </svg>
    );
});

Logo.displayName = 'Logo';
